import { render, staticRenderFns } from "./procedure_for_filling_out_the_declaration.vue?vue&type=template&id=481275e6&scoped=true&"
import script from "./procedure_for_filling_out_the_declaration.vue?vue&type=script&lang=js&"
export * from "./procedure_for_filling_out_the_declaration.vue?vue&type=script&lang=js&"
import style0 from "./procedure_for_filling_out_the_declaration.vue?vue&type=style&index=0&id=481275e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481275e6",
  null
  
)

export default component.exports